(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;

  const aiStep = U.aiStep;
  const applyAiFromSetup = U.applyAiFromSetup;
  const artStyle = U.artStyle;
  const branchHere = U.branchHere;
  const cardTitle = U.cardTitle;
  const clickCard = U.clickCard;
  const computeLegal = U.computeLegal;
  const costChip = U.costChip;
  const dispatch = U.dispatch;
  const el = U.el;
  const esc = U.esc;
  const exportGame = U.exportGame;
  const importGame = U.importGame;
  const jumpTo = U.jumpTo;
  const live = U.live;
  const loadGame = U.loadGame;
  const maybeAI = U.maybeAI;
  const newGame = U.newGame;
  const positionCardMenu = U.positionCardMenu;
  const renderBattlefields = U.renderBattlefields;
  const renderCardMenu = U.renderCardMenu;
  const renderChoiceMenu = U.renderChoiceMenu;
  const renderPlate = U.renderPlate;
  const renderPrompt = U.renderPrompt;
  const renderSelPanel = U.renderSelPanel;
  const renderSide = U.renderSide;
  const saveLocal = U.saveLocal;
  const setShowLog = U.setShowLog;
  const viewPlayer = U.viewPlayer;
  const LOG_KEY = U.LOG_KEY;
  const renderMenu = U.renderMenu;
  const renderBuilder = U.renderBuilder;

  function renderManual(state) {
    const details = el("details");
    details.id = "manualpanel";
    details.appendChild(el("summary", null, "Manual palette"));
    const body = el("div", "mbody");

    const mkBtn = function (label, fn) {
      const b = el("button", "btn", label);
      b.onclick = fn;
      body.appendChild(b);
    };
    const selArg = function () { return APP.selection; };
    const needSel = function (fn) {
      return function () {
        if (!APP.selection || !state.objs[APP.selection]) { APP.error = "Select a card first."; render(); return; }
        fn();
      };
    };
    const pSel = el("select");
    pSel.innerHTML = "<option value='0'>" + esc(state.players[0].name) + "</option><option value='1'>" + esc(state.players[1].name) + "</option>";
    body.appendChild(pSel);
    const P = function () { return +pSel.value; };

    mkBtn("Draw 1", function () { dispatch({ type: "MANUAL", op: "draw", args: { player: P(), n: 1 } }); });
    mkBtn("+1⚡", function () { dispatch({ type: "MANUAL", op: "energy", args: { player: P(), n: 1 } }); });
    mkBtn("+1 any power", function () { dispatch({ type: "MANUAL", op: "power", args: { player: P(), domain: "any", n: 1 } }); });
    mkBtn("+1 pt", function () { dispatch({ type: "MANUAL", op: "points", args: { player: P(), n: 1 } }); });
    mkBtn("-1 pt", function () { dispatch({ type: "MANUAL", op: "points", args: { player: P(), n: -1 } }); });
    mkBtn("+1 XP", function () { dispatch({ type: "MANUAL", op: "xp", args: { player: P(), n: 1 } }); });
    mkBtn("Recruit token", function () { dispatch({ type: "MANUAL", op: "token", args: { name: "Recruit", player: P() } }); });
    mkBtn("Sel: +1 dmg", needSel(function () { dispatch({ type: "MANUAL", op: "damage", args: { iid: selArg(), n: 1, player: P() } }); }));
    mkBtn("Sel: heal", needSel(function () { dispatch({ type: "MANUAL", op: "heal", args: { iid: selArg() } }); }));
    mkBtn("Sel: buff", needSel(function () { dispatch({ type: "MANUAL", op: "buff", args: { iid: selArg(), n: 1 } }); }));
    mkBtn("Sel: +1M turn", needSel(function () { dispatch({ type: "MANUAL", op: "might", args: { iid: selArg(), n: 1 } }); }));
    mkBtn("Sel: -1M turn", needSel(function () { dispatch({ type: "MANUAL", op: "might", args: { iid: selArg(), n: -1 } }); }));
    mkBtn("Sel: kill", needSel(function () { dispatch({ type: "MANUAL", op: "kill", args: { iid: selArg() } }); }));
    mkBtn("Sel: banish", needSel(function () { dispatch({ type: "MANUAL", op: "banish", args: { iid: selArg() } }); }));
    mkBtn("Sel: to hand", needSel(function () { dispatch({ type: "MANUAL", op: "toHand", args: { iid: selArg() } }); }));
    mkBtn("Sel: trash", needSel(function () { dispatch({ type: "MANUAL", op: "trash", args: { iid: selArg() } }); }));
    mkBtn("Sel: recycle", needSel(function () { dispatch({ type: "MANUAL", op: "recycle", args: { iid: selArg() } }); }));
    mkBtn("Sel: ready", needSel(function () { dispatch({ type: "MANUAL", op: "ready", args: { iid: selArg() } }); }));
    mkBtn("Sel: exhaust", needSel(function () { dispatch({ type: "MANUAL", op: "exhaust", args: { iid: selArg() } }); }));
    mkBtn("Sel: detach", needSel(function () { dispatch({ type: "MANUAL", op: "detach", args: { iid: selArg() } }); }));
    mkBtn("Sel: stun/unstun", needSel(function () { dispatch({ type: "MANUAL", op: "stun", args: { iid: selArg() } }); }));
    mkBtn("Sel: to base", needSel(function () {
      const o = state.objs[selArg()];
      dispatch({ type: "MANUAL", op: "move", args: { iid: selArg(), dest: { t: "base", p: o.controller }, player: P() } });
    }));
    for (let b = 0; b < state.battlefields.length; b++) {
      (function (b) {
        mkBtn("Sel: to BF" + (b + 1), needSel(function () {
          dispatch({ type: "MANUAL", op: "move", args: { iid: selArg(), dest: { t: "bf", iid: state.battlefields[b] }, player: P() } });
        }));
      })(b);
    }

    details.appendChild(body);
    return details;
  }

  const LOG_KIND = {
    turn: { g: "\u2756", t: "Turn" },
    phase: { g: "\u25aa", t: "Phase" },
    play: { g: "\u25b6", t: "Card played" },
    activate: { g: "\u2726", t: "Ability activated" },
    trigger: { g: "\u26a1", t: "Triggered ability" },
    resolve: { g: "\u2713", t: "Chain item resolves" },
    counter: { g: "\u2716", t: "Countered" },
    target: { g: "\u25ce", t: "Targeting" },
    damage: { g: "\u2738", t: "Damage" },
    death: { g: "\u2620", t: "Death" },
    zone: { g: "\u21c4", t: "Zone change" },
    move: { g: "\u279c", t: "Move" },
    combat: { g: "\u2694", t: "Combat" },
    score: { g: "\u2605", t: "Scoring" },
    draw: { g: "\u270e", t: "Cards" },
    reveal: { g: "\u25c9", t: "Reveal" },
    resource: { g: "\u2b22", t: "Resources" },
    state: { g: "\u25c6", t: "State change" },
    manual: { g: "\u2699", t: "Manual" },
    game: { g: "\u2739", t: "Game" },
    info: { g: "\u00b7", t: "" },
  };

  const LOG_CHATTER = { resource: 1, phase: 1, info: 1, manual: 1, resolve: 1 };

  function rxEscape(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function logHtml(entry) {
    const html = U.fmtText(entry.msg);
    const byName = {};
    for (const r of entry.r || []) if (r.n && !byName[r.n]) byName[r.n] = r;
    const names = Object.keys(byName).sort(function (a, b) { return b.length - a.length; });
    if (!names.length) return html;
    const rx = new RegExp("(^|[^\\w-])(" + names.map(function (n) { return rxEscape(esc(n)); }).join("|") + ")(?![\\w-])", "g");
    const parts = html.split(/(<[^>]*>)/);
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].charAt(0) === "<") continue;
      parts[i] = parts[i].replace(rx, function (m, pre, hit) {
        const ref = byName[hit] || byName[hit.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"')];
        if (!ref) return m;
        return pre + "<span class='lcard " + U.pcls(ref.p) + (ref.g ? " ltarget" : "") + "'" +
          " data-iid='" + esc(ref.i) + "'" + (ref.c ? " data-card='" + esc(ref.c) + "'" : "") + ">" + hit + "</span>";
      });
    }
    return parts.join("");
  }

  function logPop(card) {
    let pop = document.getElementById("logpop");
    if (!pop) {
      pop = el("div");
      pop.id = "logpop";
      document.body.appendChild(pop);
    }
    if (!card) { pop.style.display = "none"; return null; }
    pop.innerHTML = "";
    const art = el("div", "logpopart");
    U.artStyleCard(art, card, "full", 240);
    pop.appendChild(art);
    pop.appendChild(el("div", "logpopname", esc(card.name)));
    if (card.text) pop.appendChild(el("div", "logpoptext", U.fmtText(U.stripReminder ? U.stripReminder(card.text) : card.text)));
    pop.style.display = "block";
    return pop;
  }

  function wireLogCards(state, row) {
    const nodes = row.querySelectorAll(".lcard");
    for (let i = 0; i < nodes.length; i++) {
      (function (node) {
        const iid = node.getAttribute("data-iid");
        const cardId = node.getAttribute("data-card");
        const live = iid && state.objs[iid];
        const card = live ? Core.card(state, iid) : (cardId ? RB.Setup.findCard(cardId) : null);
        if (card) node.title = card.name;
        node.onmouseenter = function (ev) {
          U.flashBoardCard(iid, true);
          const pop = logPop(card);
          if (!pop) return;
          const r = node.getBoundingClientRect();
          pop.style.left = Math.min(window.innerWidth - 226, r.right + 10) + "px";
          pop.style.top = Math.max(8, Math.min(window.innerHeight - 340, r.top - 40)) + "px";
        };
        node.onmouseleave = function () {
          U.flashBoardCard(iid, false);
          logPop(null);
        };
        node.onclick = function (ev) {
          if (window.UIDOM.textSelected()) return;
          U.flashBoardCard(iid, false);
          logPop(null);
          ev.stopPropagation();
          U.peekCard(card);
        };
      })(nodes[i]);
    }
  }

  const LOG_SHAPE = {
    turn: "spine", phase: "spine", game: "spine",
    play: "cast", activate: "cast", trigger: "cast", resolve: "cast",
    counter: "cast", state: "cast",
    target: "strike", damage: "strike",
    move: "travel", zone: "travel",
    death: "exit",
    draw: "tally", resource: "tally",
    combat: "arena", score: "arena",
    reveal: "reveal",
    manual: "note", info: "note",
  };

  const SHAPE_ART = { cast: 2, strike: 1, travel: 2, exit: 2, arena: 1, reveal: 4 };

  const ARROW_SVG =
    "<svg width='11' height='7' viewBox='0 0 11 7' fill='none' stroke='currentColor'" +
    " stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'>" +
    "<path d='M0.9 3.5h8M6.7 1l2.4 2.5-2.4 2.5'></path></svg>";

  function logRefs(entry) {
    const actors = [];
    const targets = [];
    for (const r of entry.r || []) (r.g ? targets : actors).push(r);
    return { actors: actors, targets: targets };
  }

  function logShape(kind, refs) {
    let s = LOG_SHAPE[kind] || "note";
    if (refs.targets.length && (s === "cast" || s === "travel")) s = "strike";
    if (!refs.targets.length && s === "strike") s = refs.actors.length ? "cast" : "note";
    if (!refs.actors.length && (s === "arena" || s === "reveal" || s === "exit")) s = "note";
    return s;
  }

  function logRefCard(state, ref) {
    if (!ref) return null;
    if (ref.i && state.objs[ref.i]) return Core.card(state, ref.i);
    return ref.c ? RB.Setup.findCard(ref.c) : null;
  }

  function logThumb(state, ref, cls) {
    const card = logRefCard(state, ref);
    const land = !!card && (card.types || []).indexOf("battlefield") >= 0;
    const t = el("span", "lcard lthumb " + cls + (land ? " lland" : "") + " " + U.pcls(ref.p));
    t.setAttribute("data-iid", ref.i);
    if (ref.c) t.setAttribute("data-card", ref.c);
    if (card) {
      U.artStyleCard(t, card, land ? "bf" : "art", land ? 140 : 56);
    } else {
      t.classList.add("lnoart");
      t.textContent = String(ref.n || "?").charAt(0).toUpperCase();
    }
    return t;
  }

  function logStrip(state, refs, max, cls) {
    const wrap = el("span", "lstrip");
    const n = Math.min(refs.length, max);
    for (let i = 0; i < n; i++) wrap.appendChild(logThumb(state, refs[i], cls));
    if (refs.length > n) wrap.appendChild(el("span", "lmore", "+" + (refs.length - n)));
    return wrap;
  }

  function logBadge(kind) {
    const badge = el("span", "lk", LOG_KIND[kind].g);
    badge.title = LOG_KIND[kind].t;
    return badge;
  }

  function logSpine(state, e, kind) {
    const band = el("div", "lband sspine k" + kind +
      (e.p === 0 || e.p === 1 ? " " + U.pcls(e.p) : ""));
    band.appendChild(logBadge(kind));
    band.appendChild(el("span", "lbandn", logHtml(e)));
    wireLogCards(state, band);
    return band;
  }

  function logRow(state, e, kind, recent) {
    const refs = logRefs(e);
    const shape = logShape(kind, refs);
    if (shape === "spine") return logSpine(state, e, kind);

    const row = el("div", "entry k" + kind + " s" + shape +
      (e.p === 0 || e.p === 1 ? " " + U.pcls(e.p) : "") + (recent ? " recent" : ""));

    const artMax = SHAPE_ART[shape];
    if (artMax && refs.actors.length) {
      row.appendChild(logStrip(state, refs.actors, artMax, "lactor"));
    } else if (shape === "tally" && (e.p === 0 || e.p === 1)) {
      row.appendChild(el("span", "lpip"));
    }
    if (kind === "state") row.classList.add("saura");

    const body = el("div", "lbody");
    const line = el("div", "lline");
    line.appendChild(logBadge(kind));
    line.appendChild(el("span", "lm", logHtml(e)));
    body.appendChild(line);

    if (shape === "strike" && refs.targets.length) {
      const tl = el("div", "ltgt");
      tl.appendChild(el("span", "larrow", ARROW_SVG));
      tl.appendChild(logStrip(state, refs.targets, 3, "ltarg"));
      body.appendChild(tl);
    }

    row.appendChild(body);
    wireLogCards(state, row);
    return row;
  }

  const FOLD_ARENA = { combat: 1, score: 1 };
  const FOLD_TALLY = { resource: 1, draw: 1 };
  const FOLD_CAP = 4;

  function foldKey(e, kind, refs) {
    if (FOLD_ARENA[kind]) return refs.actors.length ? "arena:" + refs.actors[0].i : null;
    if (FOLD_TALLY[kind] && (e.p === 0 || e.p === 1)) return "tally:" + e.p;
    return null;
  }

  function foldGroups(entries, base) {
    const groups = [];
    for (let i = 0; i < entries.length; i++) {
      const e = entries[i];
      const kind = LOG_KIND[e.k] ? e.k : "info";
      const refs = logRefs(e);
      const key = foldKey(e, kind, refs) || "dup:" + kind + ":" + e.msg;
      const last = groups[groups.length - 1];
      if (last && last.key === key && last.turn === e.t && kind !== "turn") {
        last.members.push({ e: e, kind: kind, refs: refs, idx: base + i });
        continue;
      }
      groups.push({
        key: key, turn: e.t, idx: base + i,
        type: key.indexOf("arena:") === 0 ? "arena" : key.indexOf("tally:") === 0 ? "tally" : "dup",
        members: [{ e: e, kind: kind, refs: refs, idx: base + i }],
      });
    }
    return groups;
  }

  function foldHead(g) {
    if (g.type === "arena") {
      for (let i = g.members.length - 1; i >= 0; i--) if (g.members[i].kind === "score") return g.members[i];
    }
    return g.members[0];
  }

  function tallyHtml(state, g) {
    const name = state.players[g.members[0].e.p];
    const lead = name ? name.name : "";
    const shown = g.members.slice(0, FOLD_CAP);
    const parts = [];
    for (const m of shown) {
      let msg = m.e.msg.replace(/\.\s*$/, "");
      if (lead && msg.indexOf(lead + " ") === 0) msg = msg.slice(lead.length + 1);
      parts.push(logHtml({ msg: msg, r: m.e.r }));
    }
    const more = g.members.length - shown.length;
    return (lead ? "<b class='ltname'>" + esc(lead) + "</b> " : "") +
      parts.join(" <span class='lsep'>\u00b7</span> ") +
      (more > 0 ? " <span class='lsep'>+" + more + "</span>" : "");
  }

  function foldChip(g, open) {
    const chip = el("span", "lfoldn" + (open ? " on" : ""),
      (g.type === "dup" ? "\u00d7" : "") + g.members.length);
    chip.title = open ? "Collapse these " + g.members.length + " entries" : "Show all " + g.members.length + " entries";
    return chip;
  }

  function foldRow(state, g, recent) {
    const open = !!APP.logOpen[g.idx];
    const head = foldHead(g);
    let row;
    if (g.type === "tally") {
      row = el("div", "entry k" + head.kind + " stally lfold" +
        (head.e.p === 0 || head.e.p === 1 ? " " + U.pcls(head.e.p) : "") + (recent ? " recent" : ""));
      row.appendChild(el("span", "lpip"));
      const body = el("div", "lbody");
      const line = el("div", "lline");
      line.appendChild(logBadge(head.kind));
      line.appendChild(el("span", "lm", tallyHtml(state, g)));
      line.appendChild(foldChip(g, open));
      body.appendChild(line);
      row.appendChild(body);
      wireLogCards(state, row);
    } else {
      row = logRow(state, head.e, head.kind, recent);
      row.classList.add("lfold");
      const body = row.children[row.children.length - 1];
      const line = body && body.children ? body.children[0] : null;
      (line || row).appendChild(foldChip(g, open));
    }
    row.onclick = function (ev) {
      const t = ev && ev.target;
      if (t && t.classList && t.classList.contains("lcard")) return;
      if (window.UIDOM.textSelected()) return;
      APP.logOpen[g.idx] = !open;
      U.render();
    };
    return row;
  }

  function renderLog(state) {
    logPop(null);
    const div = el("div");
    div.id = "log";
    const all = state.gameLog.slice(-400);
    const base = state.gameLog.length - all.length;
    const kept = [];
    for (let i = 0; i < all.length; i++) {
      if (APP.logDetail || !LOG_CHATTER[all[i].k || "info"]) kept.push({ e: all[i], idx: base + i });
    }
    const groups = foldGroups(kept.map(function (x) { return x.e; }), 0)
      .map(function (g) {
        g.idx = kept[g.idx] ? kept[g.idx].idx : g.idx;
        for (const m of g.members) m.idx = kept[m.idx] ? kept[m.idx].idx : m.idx;
        return g;
      });
    let turn = null;
    for (let gi = 0; gi < groups.length; gi++) {
      const g = groups[gi];
      const head = g.members[0];
      const recent = gi >= groups.length - 5;
      if (head.kind === "turn") {
        turn = g.turn;
        const bar = el("div", "lturn");
        bar.appendChild(el("span", "lturnn", U.fmtText(head.e.msg)));
        div.appendChild(bar);
        continue;
      }
      if (g.turn !== turn) {
        turn = g.turn;
        const bar = el("div", "lturn");
        bar.appendChild(el("span", "lturnn", "TURN " + turn));
        div.appendChild(bar);
      }
      if (g.members.length < 2) {
        div.appendChild(logRow(state, head.e, head.kind, recent));
        continue;
      }
      div.appendChild(foldRow(state, g, recent));
      if (APP.logOpen[g.idx]) {
        for (const m of g.members) {
          const sub = logRow(state, m.e, m.kind, false);
          sub.classList.add("lsub");
          div.appendChild(sub);
        }
      }
    }
    if (!groups.length) div.appendChild(el("div", "entry kinfo snote", "Nothing has happened yet."));
    return div;
  }

  function renderSidebar(state) {
    if (!APP.showLog && !APP.showManual) return null;
    const rail = el("div");
    rail.id = "siderail";
    if (APP.showLog) {
      const head = el("div", "railhead");
      head.appendChild(el("h4", null, "Duel Log"));
      const detail = el("button", "btn railtog" + (APP.logDetail ? " on" : ""), APP.logDetail ? "All" : "Key");
      detail.title = APP.logDetail
        ? "Showing every entry. Click for key plays only (hides costs, phases and resolutions)."
        : "Showing key plays only. Click to show every entry.";
      detail.onclick = function () { U.setLogDetail(!APP.logDetail); };
      head.appendChild(detail);
      const x = el("button", "btn closex", "<svg width='11' height='11' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round'><path d='M4 4l8 8M12 4l-8 8'></path></svg>");
      x.title = "Hide the duel log (L)";
      x.onclick = function () { setShowLog(false); };
      head.appendChild(x);
      rail.appendChild(head);
      rail.appendChild(renderLog(state));
    }
    if (APP.showManual && !APP.net) rail.appendChild(renderManual(state));
    return rail;
  }

  function showSetupDialog() {
    const dlg = document.getElementById("piledlg");
    dlg.innerHTML = "";
    dlg.appendChild(el("h3", null, "New game from setup JSON"));
    dlg.appendChild(el("div", "note", "Cards are referenced by exact name or id (e.g. \"ogn-027-298\"). Legends/champions/battlefields by name work too. Edit and start."));
    const ta = document.createElement("textarea");
    ta.style.width = "620px";
    ta.style.height = "320px";
    ta.style.background = "#0a101d";
    ta.style.color = "#dde5f2";
    ta.style.marginTop = "8px";
    ta.value = JSON.stringify(APP.game ? APP.game.setup : RB.DEMO_SETUP, null, 1);
    dlg.appendChild(ta);
    const row = el("div", "actions");
    row.style.marginTop = "10px";
    const go = el("button", "btn primary", "Start game");
    go.onclick = function () {
      try {
        const setup = JSON.parse(ta.value);
        dlg.close();
        newGame(setup);
      } catch (e) {
        alert("Setup error: " + e.message);
      }
    };
    const close = el("button", "btn", "Cancel");
    close.onclick = function () { dlg.close(); };
    row.appendChild(go);
    row.appendChild(close);
    dlg.appendChild(row);
    dlg.showModal();
  }

  function renderFullCard(state, iid) {
    const c = Core.card(state, iid);
    const div = el("div", "card fullcard");
    if (!c) return div;
    div.setAttribute("data-iid", iid);
    artStyle(div, state, iid, "full", 200);
    div.title = cardTitle(state, iid);
    if (c.energy !== null && c.energy !== undefined) {
      div.appendChild(costChip(state, iid, c));
    }
    div.appendChild(el("span", "hname", esc(c.name)));
    div.onclick = function (ev) { clickCard(iid, ev); };
    return div;
  }

  function showPile(title, iids, full) {
    const dlg = document.getElementById("piledlg");
    dlg.innerHTML = "";
    dlg.appendChild(el("h3", null, esc(title)));
    const row = el("div", "cardrow");
    row.style.marginTop = "10px";
    for (const iid of iids) {
      const card = full ? renderFullCard(APP.state, iid) : renderPlate(APP.state, iid);
      const inner = card.onclick;
      card.onclick = function (ev) {
        dlg.close();
        if (inner) inner(ev);
      };
      row.appendChild(card);
    }
    if (!iids.length) row.appendChild(el("span", "zlabel", "Empty"));
    dlg.appendChild(row);
    const close = el("button", "btn", "Close");
    close.style.marginTop = "10px";
    close.onclick = function () { dlg.close(); };
    dlg.appendChild(close);

    dlg.onclick = function (ev) { if (ev.target === dlg) dlg.close(); };
    dlg.showModal();
  }

  function renderModalTab(state) {
    const pd = state.pending;
    const tab = el("div");
    tab.id = "modaltab";
    tab.title = "Click to bring the window back (or right-click anywhere).";
    tab.appendChild(el("span", "mtarrow", "▲"));
    const label = pd && pd.prompt ? U.fmtText(pd.prompt) : (pd && pd.kind ? esc(pd.kind) : "Window");
    tab.appendChild(el("span", "mtlabel", label));
    tab.onclick = function (ev) { ev.stopPropagation(); U.setModalMin(false); };
    return tab;
  }

  function drawerButton(label, cls, title, onClick) {
    const b = el("button", cls || null, label);
    if (title) b.title = title;
    if (!onClick) b.disabled = true;
    else b.onclick = function (ev) { ev.stopPropagation(); onClick(); };
    return b;
  }

  function drawerSection(title, buttons) {
    const sec = el("div", "drsec");
    sec.appendChild(el("div", "zlabel drtitle", title));
    const row = el("div", "drrow");
    for (const b of buttons) if (b) row.appendChild(b);
    sec.appendChild(row);
    return sec;
  }

  function renderDrawer(state) {
    const online = !!APP.net;
    const legacyBoard = APP.boardSkin !== "arena";
    const wrap = el("div");
    wrap.id = "drawer";
    wrap.onclick = function (ev) { ev.stopPropagation(); };
    const head = el("div", "drhead");
    head.appendChild(el("span", "drname", "Table"));
    head.appendChild(drawerButton("✕", "closex", "Close (Esc)", function () { U.setDrawer(false); }));
    wrap.appendChild(head);

    const table = [
      drawerButton("Board: " + (legacyBoard ? "Classic · LEGACY" : "Arena"), legacyBoard ? "on" : null,
        legacyBoard ? "You are on the retired Classic board. Arena is the current one."
          : "Board layout. Arena is the current board; Classic is retired and kept only for comparison.",
        function () { U.setBoardSkin(APP.boardSkin === "arena" ? "classic" : "arena"); }),
      !online ? drawerButton("View: " + (APP.viewAs === "auto" ? "Auto" : esc(state.players[APP.viewAs].name)), null,
        "Which player's seat the table is drawn from. Auto follows whoever must act.",
        function () { APP.viewAs = APP.viewAs === "auto" ? 0 : APP.viewAs === 0 ? 1 : "auto"; render(); }) : null,
      !legacyBoard ? drawerButton("Glow: " + APP.prioGlow.charAt(0).toUpperCase() + APP.prioGlow.slice(1), null,
        "Priority cue on the side that must act. Soft: tint only. Edge: tint + sweeping streak. Strong: the same, louder. Frame: pulsing border around the half. Wave: light rolling from the centre to your edge. Off: none.",
        function () { const list = U.PRIO_GLOWS; U.setPrioGlow(list[(list.indexOf(APP.prioGlow) + 1) % list.length]); }) : null,
      drawerButton("Anim: " + (RB.Anim.speed === 0 ? "Off" : RB.Anim.speed > 2 ? "Faster" : RB.Anim.speed > 1 ? "Fast" : "Normal"), null,
        "Pacing of event animations. Every animation follows this one factor.", function () {
          RB.Anim.speed = RB.Anim.speed === 0 ? 1 : RB.Anim.speed === 1 ? 1.8 : RB.Anim.speed <= 2 ? 3 : 0;
          if (RB.Anim.speed === 0) RB.Anim.flush();
          try { localStorage.setItem("riftbound-anim-speed", String(RB.Anim.speed)); } catch (e) { }
          render();
        }),
    ];
    wrap.appendChild(drawerSection("Board", table));

    const panels = [
      drawerButton("Log: " + (APP.showLog ? "On" : "Off"), APP.showLog ? "on" : null,
        "The duel log: every action taken and the cards it touched (shortcut: L).",
        function () { setShowLog(!APP.showLog); }),
      !online ? drawerButton("Manual: " + (APP.showManual ? "On" : "Off"), APP.showManual ? "on" : null,
        "Manual palette — the debug controls for applying an unautomated effect by hand.",
        function () { U.setShowManual(!APP.showManual); }) : null,
      !online ? drawerButton("Replay: " + (APP.showReplay ? "On" : "Off"), APP.showReplay ? "on" : null,
        "Timeline scrubber to review or branch from earlier actions.",
        function () { U.setShowReplay(!APP.showReplay); }) : null,
    ];
    wrap.appendChild(drawerSection("Panels", panels));

    if (online) {
      wrap.appendChild(drawerSection("Game", [
        drawerButton("Leave", "danger", "Leaving concedes the game to your opponent.", function () {
          if (confirm("Leave this game? Your opponent wins by concession.")) APP.net.leave();
        }),
      ]));
      return wrap;
    }
    const inMatch = APP.match && RB.Match.isMatch(APP.match);
    if (inMatch) {
      wrap.appendChild(drawerSection("Match", [
        drawerButton("Score " + RB.Match.score(APP.match), null,
          RB.Match.label(APP.match) + " — game " + APP.match.gameNo + ". Concede sends this game to your opponent; forfeiting ends the whole match.", null),
        drawerButton("Forfeit match", "danger", "Give up the match and return to the menu.", function () {
          if (!confirm("Forfeit this match at " + RB.Match.score(APP.match) + "?")) return;
          U.clearMatch();
          APP.screen = "menu";
          render();
        }),
      ]));
    }
    wrap.appendChild(drawerSection("Game", [
      !inMatch ? drawerButton("Rematch", null, "Same decks and pilots, fresh random seed.", function () {
        const s2 = JSON.parse(JSON.stringify(APP.game.setup));
        s2.seed = Math.floor(Math.random() * 2147483647);
        s2.firstPlayer = Math.random() < 0.5 ? 0 : 1;
        if (confirm("Start a rematch with seed " + s2.seed + "?")) newGame(s2);
      }) : null,
      drawerButton("New from JSON…", null, null, showSetupDialog),
      drawerButton("Export", null, null, exportGame),
      drawerButton("Import", null, null, function () { document.getElementById("filein").click(); }),
      drawerButton("Concede", "danger", null, function () {
        const p = state.pending && state.pending.player !== undefined ? state.pending.player : state.turn.player;
        if (confirm(state.players[p].name + " concedes?")) dispatch({ type: "CONCEDE", player: p });
      }),
      drawerButton("Menu", null, APP.watch ? "Leave the game and go back to the play page." : "Back to the main menu.", function () {
        if (APP.watch) { U.watchStop(); location.href = "/play"; return; }
        APP.screen = "menu";
        render();
      }),
    ]));
    return wrap;
  }

  function renderTopbar(state) {
    const online = !!APP.net;
    const top = el("div");
    top.id = "topbar";
    if (online) {
      const seatChip = el("span", "seatchip", "SEAT · " + esc(state.players[APP.seat] ? state.players[APP.seat].name : "?"));
      seatChip.title = "You play this seat. The server only ever sends you what this seat may see.";
      top.appendChild(seatChip);
      const vs = el("span", "seatchip vs", "VS · " + esc(APP.net.opponentName ? APP.net.opponentName() : "Opponent"));
      vs.title = "Your opponent's hand, deck and hidden cards never leave the server.";
      top.appendChild(vs);
    }
    const chip = U.matchChip();
    if (chip) top.appendChild(chip);
    const open = el("button", APP.drawer ? "on" : null, "☰");
    open.title = "Table settings, panels and game actions.";
    open.onclick = function (ev) { ev.stopPropagation(); U.setDrawer(!APP.drawer); };
    top.appendChild(open);
    return top;
  }

  const TRAINER_BRANCH_KEY = "riftbound-trainer-branch";

  function loadTrainerBranch() {
    let branch = null;
    try {
      const raw = localStorage.getItem(TRAINER_BRANCH_KEY);
      if (raw) {
        localStorage.removeItem(TRAINER_BRANCH_KEY);
        branch = JSON.parse(raw);
      }
    } catch (e) { }
    if (!branch || !branch.game || !branch.game.setup || !Array.isArray(branch.game.log)) return;
    const seat = branch.seat === 1 ? 1 : 0;
    const upto = Math.max(0, Math.min(branch.game.log.length, Number(branch.upto) || 0));
    const setup = JSON.parse(JSON.stringify(branch.game.setup));
    setup.ai = [false, false];
    setup.ai[seat === 0 ? 1 : 0] = "native:" + (U.NATIVE_STRENGTHS.indexOf(branch.strength) >= 0 ? branch.strength : "quick");
    const game = { version: branch.game.version, setup: setup, log: branch.game.log.slice(0, upto) };
    if (!loadGame(game, "The reviewed position")) return;
    U.applyAiFromSetup();
    APP.screen = "game";
    APP.showReplay = true;
    U.saveLocal();
    window.UIDOM.showNotice("Loaded the reviewed position at action " + upto +
      ". You are " + APP.state.players[seat].name + "; the native player takes the other seat.");
  }

  function trainerSeats(state) {
    return state.players.map(function (p) { return p.name; });
  }

  function humanSeats() {
    return [0, 1].filter(function (p) { return !APP.ai[p]; });
  }

  function postTrainer(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  let rated = null;

  function maybeRate(state) {
    if (!state.over || APP.net) return;
    const humans = humanSeats();
    if (humans.length !== 1) return;
    const seat = humans[0];
    const foe = seat === 0 ? 1 : 0;
    const strength = U.nativeStrength(foe);
    if (!strength) return;
    const key = APP.game.setup.seed + ":" + APP.game.log.length + ":" + seat;
    if (rated === key) return;
    rated = key;
    postTrainer("/api/trainer/result", {
      opponent: "native",
      strength: strength,
      result: state.over.winner === seat ? "win" : "loss",
    }).then(function (j) {
      if (j && j.rating) APP.trainerRating = Math.round(j.rating.rating);
      render();
    }).catch(function () { });
  }

  function renderReviewBar(state) {
    const bar = el("div", "revbar");
    const seats = humanSeats();
    const mine = seats.length ? seats[0] : 0;
    const line = el("span", "revnote", APP.trainerRating ? "Rating now " + APP.trainerRating + "." : "");
    const save = el("button", "btn small", "Save for review");
    save.title = "Store this game on the server so the native player can analyse your decisions.";
    save.onclick = function () {
      save.disabled = true;
      line.textContent = "Saving…";
      postTrainer("/api/trainer/games", {
        game: { version: APP.game.version, setup: APP.game.setup, log: APP.game.log },
        seats: trainerSeats(state),
        source: "local",
      }).then(function (j) {
        if (!j || j.error) throw new Error((j && j.error) || "save failed");
        line.textContent = "Saved as " + j.id + ".";
        bar.appendChild(reviewButton(j.id, mine, state));
      }).catch(function (e) {
        save.disabled = false;
        line.textContent = "Could not save: " + e.message;
      });
    };
    bar.appendChild(save);
    bar.appendChild(line);
    return bar;
  }

  function reviewButton(gameId, seat, state) {
    const go = el("button", "btn small primary", "Review my play (" + esc(state.players[seat].name) + ")");
    go.onclick = function () {
      go.disabled = true;
      postTrainer("/api/trainer/review", { gameId: gameId, seat: seat, strength: "quick" }).then(function (j) {
        if (!j || j.error) throw new Error((j && j.error) || "queue failed");
        location.href = "/trainer#reviews";
      }).catch(function (e) {
        go.disabled = false;
        go.textContent = "Could not queue: " + e.message;
      });
    };
    return go;
  }

  function renderReplaybar() {
    const rb = el("div");
    rb.id = "replaybar";
    rb.appendChild(el("span", "stat", "REPLAY"));
    const range = document.createElement("input");
    range.type = "range";
    range.min = 0;
    range.max = APP.game.log.length;
    range.value = live() ? APP.game.log.length : APP.viewIndex;
    range.oninput = function () { jumpTo(+range.value); };
    rb.appendChild(range);
    const pos = live() ? "Action " + APP.game.log.length + " / " + APP.game.log.length + " · LIVE" : "Viewing action " + APP.viewIndex + " / " + APP.game.log.length;
    rb.appendChild(el("span", live() ? "stat" : "viewing", pos));
    const back = el("button", "btn", "<svg width='9' height='9' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='2'><path d='M10 3L5 8l5 5'></path></svg>");
    back.onclick = function () { jumpTo(Math.max(0, (live() ? APP.game.log.length : APP.viewIndex) - 1)); };
    rb.appendChild(back);
    const fwd = el("button", "btn", "<svg width='9' height='9' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='2'><path d='M6 3l5 5-5 5'></path></svg>");
    fwd.onclick = function () { jumpTo(Math.min(APP.game.log.length, (live() ? APP.game.log.length : APP.viewIndex) + 1)); };
    rb.appendChild(fwd);
    const liveBtn = el("button", "btn", "Latest");
    liveBtn.onclick = function () { jumpTo(APP.game.log.length); };
    rb.appendChild(liveBtn);
    if (!live()) {
      const cont = el("button", "btn danger", "Continue from here (discards future)");
      cont.onclick = function () {
        if (confirm("Discard " + (APP.game.log.length - APP.viewIndex) + " later action(s) and continue from this point?")) branchHere();
      };
      rb.appendChild(cont);
    }
    return rb;
  }

  function render() {
    const body = typeof document !== "undefined" && document.body && document.body.classList
      ? document.body.classList : null;
    if (body) body.remove("grouping");
    if (APP.screen === "home") { U.renderHome(); return; }
    if (APP.screen === "menu") { renderMenu(); return; }
    if (APP.screen === "builder") { renderBuilder(); return; }
    if (APP.screen === "match") { U.renderMatchScreen(); return; }
    if (APP.screen === "pregame") { U.renderPregame(); return; }
    if (APP.screen === "testbench") { TB.renderBench(); return; }
    if (APP.screen === "watchlist") { U.renderWatchList(); return; }
    const state = APP.state;
    const root = document.getElementById("app");
    const minds = APP.watch ? U.mindsNode() : null;
    for (let n = root.firstChild; n;) { const next = n.nextSibling; if (n !== minds) root.removeChild(n); n = next; }
    root.className = APP.showLog || (APP.showManual && !APP.net) ? "railopen" : "";
    U.LEGAL = computeLegal(state);
    const me = viewPlayer(state);
    const opp = Core.otherPlayer(me);

    const arena = APP.boardSkin === "arena";
    root.classList.toggle("arenaskin", arena);
    root.classList.toggle("watching", !!APP.watch);
    root.appendChild(renderTopbar(state));
    if (APP.drawer) root.appendChild(renderDrawer(state));
    let table;
    if (arena) {
      table = U.renderArena(state);
      root.appendChild(table);
    } else {
      root.appendChild(renderSide(state, opp, "top"));
      table = renderBattlefields(state);
      root.appendChild(table);
      root.appendChild(renderSide(state, me, "bot"));
    }
    if (!arena) table.appendChild(renderPrompt(state));
    if (minds && minds.parentNode !== root) root.appendChild(minds);
    const tray = U.renderGroupTray(state);
    if (tray) table.appendChild(tray);
    if (body) body.toggle("grouping", !!tray);
    const rail = renderSidebar(state);
    if (rail) root.appendChild(rail);
    const sel = renderSelPanel(state);
    if (sel) root.appendChild(sel);
    const menu = renderCardMenu(state);
    if (menu) root.appendChild(menu);
    const choice = U.modalMinimized(state) ? null : renderChoiceMenu(state);
    if (choice) root.appendChild(choice);
    if (U.modalMinimized(state)) root.appendChild(renderModalTab(state));
    if (!APP.net && !APP.watch && state.over) {
      const mb = U.matchBar(state);
      if (mb) root.appendChild(mb);
      root.appendChild(renderReviewBar(state));
    }
    if (!APP.net && !APP.watch && (APP.showReplay || !live())) root.appendChild(renderReplaybar());
    if (APP.net && APP.net.overlay) {
      const ov = APP.net.overlay();
      if (ov) root.appendChild(ov);
    }
    if (window.TB) {
      const tbbar = TB.gameBar();
      if (tbbar) root.appendChild(tbbar);
    }

    if (arena) U.fitArena();
    const logEl = document.getElementById("log");
    if (logEl) logEl.scrollTop = logEl.scrollHeight;
    positionCardMenu();
    if (arena) U.positionChoiceMenu(state);
    if (RB.Anim && RB.Anim.restorePlaceholders) RB.Anim.restorePlaceholders();
    U.drainAutoPay();
    U.drainHoldPass();
    if (!APP.watch) {
      maybeRate(state);
      U.recordFinishedMatchGame(state);
    }
    maybeAI();
  }

  window.UI = {
    boot(opts) {
      const cfg = opts || {};
      APP.mode = cfg.mode || "play";
      if (RB.Anim) {
        RB.Anim.onIdle = function () {
          if (U.IDLE_RENDER && APP.screen === "game" && APP.game) render();
          else maybeAI();
        };
        try {
          const sp = localStorage.getItem("riftbound-anim-speed");
          if (sp !== null && sp !== "") RB.Anim.speed = +sp;
        } catch (e) { }
      }
      try {
        if (localStorage.getItem(U.BOARD_SKIN_KEY) === "classic") APP.boardSkin = "classic";
        const glow = localStorage.getItem(U.PRIO_GLOW_KEY);
        if (glow && U.PRIO_GLOWS.indexOf(glow) >= 0) APP.prioGlow = glow;
      } catch (e) { }
      try { APP.showLog = localStorage.getItem(LOG_KEY) === "1"; } catch (e) { }
      try { APP.logDetail = localStorage.getItem(U.LOG_DETAIL_KEY) !== "0"; } catch (e) { }
      try { APP.showManual = localStorage.getItem(U.SHOW_MANUAL_KEY) === "1"; } catch (e) { }
      try { APP.showReplay = localStorage.getItem(U.REPLAY_KEY) === "1"; } catch (e) { }
      try { APP.manualPay = localStorage.getItem(U.MANUAL_PAY_KEY) === "1"; } catch (e) { }
      let game = null;
      try {
        const saved = localStorage.getItem("riftbound-sim-autosave");
        if (saved) game = JSON.parse(saved);
      } catch (e) { }
      U.restoreMatch();
      if (game && game.setup && game.log && loadGame(game, "Your autosaved game")) {
        applyAiFromSetup();
        saveLocal();
      } else if (game && game.setup) {
        APP.error = APP.error || "The autosaved game could not be restored.";
      }
      APP.screen = cfg.screen || "menu";
      const deckRoute = location.pathname.match(/^\/deckbuilder\/(.+)$/);
      const wantDeck = deckRoute ? decodeURIComponent(deckRoute[1]) : null;
      const deckPending = APP.mode === "manage" && wantDeck && wantDeck !== "new" && !RB.Decklists.get(wantDeck);
      RB.Decklists.loadLibrary().then(function (arr) {
        if (!arr || !arr.length) return;
        if (deckPending) U.applyDeckRoute();
        else if (APP.screen === "menu" || APP.screen === "home") U.render();
      });
      loadTrainerBranch();
      if (cfg.screen === "testbench") TB.open();
      document.getElementById("filein").onchange = function (ev) {
        if (ev.target.files[0]) importGame(ev.target.files[0]);
        ev.target.value = "";
      };
      if (APP.mode === "watch") { U.watchBoot(); return; }
      if (APP.mode === "manage") {
        window.addEventListener("popstate", function () { U.applyDeckRoute(); });
        if (!deckPending) U.applyDeckRoute();
        return;
      }
      render();
    },
    render: render,
    importGame: importGame,
    aiStep: aiStep,
    loadTestGame(game) {
      APP.game = game;
      APP.state = Kernel.computeState(game);
      APP.viewIndex = null;
      APP.error = null;
      APP.selection = null;
      APP.picked = [];
      APP.assign = {};
      APP.moveSel = null;
      APP.payActs = [];
      APP.payPd = null;
      APP.autoPayPd = null;
      APP.ai = [false, false];
      APP.viewAs = "auto";
      APP.screen = "game";
      if (RB.Anim) RB.Anim.flush();
      render();
    },
  };

  Object.assign(U, { showPile: showPile, render: render });
})();
